import { useSelector } from "react-redux"
import { get } from "lodash"

const useQueryField = ({ moduleName }) => {
    const resumeData = useSelector(state => state.mobileEdit.data?.resumeData)

    return get(resumeData, moduleName)
}

export default useQueryField